import request from '@/utils/request'


// 查询米波站点配置列表
export function listSiteConfig(query) {
  return request({
    url: '/mibo/mibo-site-config/list',
    method: 'get',
    params: query
  })
}

// 查询米波站点配置分页
export function pageSiteConfig(query) {
  return request({
    url: '/mibo/mibo-site-config/page',
    method: 'get',
    params: query
  })
}

// 查询米波站点配置详细
export function getSiteConfig(data) {
  return request({
    url: '/mibo/mibo-site-config/detail',
    method: 'get',
    params: data
  })
}

// 新增米波站点配置
export function addSiteConfig(data) {
  return request({
    url: '/mibo/mibo-site-config/add',
    method: 'post',
    data: data
  })
}

// 修改米波站点配置
export function updateSiteConfig(data) {
  return request({
    url: '/mibo/mibo-site-config/edit',
    method: 'post',
    data: data
  })
}

// 删除米波站点配置
export function delSiteConfig(data) {
  return request({
    url: '/mibo/mibo-site-config/delete',
    method: 'post',
    data: data
  })
}
